"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordDialogBase = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var SetPassword_1 = require("../SetPassword");
var PasswordTextField_1 = require("../PasswordTextField");
var Dialog_1 = require("../Dialog");
var components_1 = require("../../components");
var screens_1 = require("../../screens");
/**
 * Component that renders a dialog with textField to enter current password and a change password form with a new password and confirm password inputs.
 * It includes callbacks so you can respond to changes in the inputs.
 *
 * @param dialogTitle title to display in the dialog
 * @param dialogDescription description to display in the dialog
 * @param currentPasswordLabel label to display for the current password field
 * @param previousLabel label to display for the previous button
 * @param nextLabel label to display for the next button
 * @param currentPasswordChange called when the current password field changes
 * @param enableButton boolean to enable and disable the button
 * @param onFinish function called when the button is clicked on success screen
 * @param onSubmit callback function to call when the form is submitted
 * @param onPrevious called when the previous button is clicked
 * @param sx styles passed to the underlying root component
 * @param loading boolean that indicates whether the loading spinner should be displayed
 * @param currentPasswordTextFieldProps props to pass to the current password field.
 * @param showSuccessScreen boolean that determines whether to show the success screen or not
 * @param slots used for ChangePasswordDialog SuccessScreen props
 * @param slotProps props that will be passed to the SuccessScreen component
 *
 * @category Component
 */
var ChangePasswordDialogBase = function (props) {
    var open = props.open, dialogTitle = props.dialogTitle, dialogDescription = props.dialogDescription, currentPasswordLabel = props.currentPasswordLabel, previousLabel = props.previousLabel, nextLabel = props.nextLabel, sx = props.sx, enableButton = props.enableButton, currentPasswordChange = props.currentPasswordChange, onSubmit = props.onSubmit, onPrevious = props.onPrevious, ErrorDialogProps = props.ErrorDialogProps, PasswordProps = props.PasswordProps, loading = props.loading, currentPasswordTextFieldProps = props.currentPasswordTextFieldProps, showSuccessScreen = props.showSuccessScreen, slots = props.slots, slotProps = props.slotProps;
    var theme = (0, material_1.useTheme)();
    var matchesMD = (0, material_1.useMediaQuery)(theme.breakpoints.down('md'));
    var matchesSM = (0, material_1.useMediaQuery)(theme.breakpoints.down('sm'));
    var _a = (0, react_1.useState)(''), currentPassword = _a[0], setCurrentPassword = _a[1];
    var _b = (0, react_1.useState)(true), buttonState = _b[0], setButtonState = _b[1];
    var handleChange = function (event) {
        var value = event.target.value;
        setCurrentPassword(value);
        currentPasswordChange === null || currentPasswordChange === void 0 ? void 0 : currentPasswordChange(value);
    };
    (0, react_1.useEffect)(function () {
        setButtonState(!enableButton);
    }, [enableButton]);
    var getSuccessScreen = function (_props, SuccessScreen) {
        return SuccessScreen ? (SuccessScreen(_props)) : (react_1.default.createElement(screens_1.SuccessScreenBase, __assign({ WorkflowCardBaseProps: {
                sx: {
                    height: matchesMD ? (matchesSM ? '100vh' : '62vh') : '70vh',
                },
            } }, _props)));
    };
    return (react_1.default.createElement(material_1.Dialog, { sx: sx, fullScreen: matchesSM, open: open, maxWidth: 'xs' },
        react_1.default.createElement(components_1.Spinner, { "data-testid": "blui-spinner", visible: loading }),
        showSuccessScreen ? (getSuccessScreen((slotProps === null || slotProps === void 0 ? void 0 : slotProps.SuccessScreen) || {}, slots === null || slots === void 0 ? void 0 : slots.SuccessScreen)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Dialog_1.BasicDialog, __assign({}, ErrorDialogProps)),
            react_1.default.createElement(material_1.DialogTitle, { sx: {
                    pt: { md: 4, sm: 2 },
                    px: { md: 3, sm: 2 },
                    pb: 0,
                } }, dialogTitle),
            react_1.default.createElement(material_1.DialogContent, { sx: {
                    flex: '1 1 auto',
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    pt: 2,
                    pb: { xs: 2, md: 3 },
                    px: { xs: 2, md: 3 },
                } },
                react_1.default.createElement(material_1.Typography, { sx: { px: { xs: 1, sm: 0 } } }, dialogDescription),
                react_1.default.createElement(material_1.Divider, { sx: { mt: 5, mb: 4, mx: { md: -3, xs: -2 } } }),
                react_1.default.createElement(SetPassword_1.SetPassword, __assign({}, PasswordProps),
                    react_1.default.createElement(PasswordTextField_1.PasswordTextField, __assign({ sx: {
                            mb: { xs: 3, md: 4 },
                        }, id: "current-password", label: currentPasswordLabel, value: currentPassword }, currentPasswordTextFieldProps, { onChange: function (e) {
                            // eslint-disable-next-line no-unused-expressions
                            (currentPasswordTextFieldProps === null || currentPasswordTextFieldProps === void 0 ? void 0 : currentPasswordTextFieldProps.onChange) &&
                                currentPasswordTextFieldProps.onChange(e);
                            handleChange(e);
                        }, onKeyUp: function (e) {
                            var _a;
                            if (e.key === 'Enter' && ((_a = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.passwordRef) === null || _a === void 0 ? void 0 : _a.current)) {
                                PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.passwordRef.current.focus();
                            }
                        } })))),
            react_1.default.createElement(material_1.Divider, null),
            react_1.default.createElement(material_1.DialogActions, { sx: {
                    justifyContent: 'flex-end',
                    p: { xs: 2, md: 3 },
                } },
                react_1.default.createElement(material_1.Grid, { container: true, direction: "row", alignItems: "center", justifyContent: "space-between", sx: { width: '100%' } },
                    react_1.default.createElement(material_1.Button, { variant: "outlined", color: "primary", sx: { width: 100 }, onClick: onPrevious }, previousLabel),
                    react_1.default.createElement(material_1.Button, { variant: "contained", disableElevation: true, sx: { width: 100 }, disabled: buttonState, color: "primary", onClick: function () {
                            void (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit());
                        } }, nextLabel)))))));
};
exports.ChangePasswordDialogBase = ChangePasswordDialogBase;
